<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "security"
}
</script>

<style scoped>

</style>